import { Badge, ConfigProvider, Space } from "antd"
import React from "react"
import { fanOnBackgroundColor, FanPausedBackgroundColor } from "src/pages/dashboard/charts/shared"

export const SystemStatusChangeBackgroundLegend = () => {

    return <ConfigProvider theme={{ components: { Badge: { fontSizeSM: 32} } }}>
        <Space direction="horizontal" size="middle">
            <Badge color="transparent" text="Machine Off" styles={{
                indicator: {
                    outline: "1px solid gray",
                }
            }} />
            <Badge color={fanOnBackgroundColor} text="Machine On" />
        </Space>
    </ConfigProvider>
}